import { useContext, useEffect, useState, useCallback } from "react";
import { Context as CampaignsContext } from "../context/CampaignsContext";
import paginatorFunc from "../helpers/paginator";

export default () => {
  const {
    state: { campaigns, links, total_reg, page_size, page, total_pages },
    getCampaigns,
    resetValues
  } = useContext(CampaignsContext);

  const [loadingCampaigns, setLoadingCampaigns] = useState(true);

  // This function won't be used unless there's a pagination component involved
  const paginator = useCallback(() => paginatorFunc(page, total_pages), [
    page,
    total_pages
  ]);

  const fetchCampaigns = useCallback(
    async ({ page = 1, filter = null }) => {
      setLoadingCampaigns(true);
      await getCampaigns(page, filter);
      setLoadingCampaigns(false);
    },
    [getCampaigns]
  );
  const reset = useCallback(resetValues, []);

  useEffect(() => {
    return () => reset();
  }, [reset]);

  useEffect(() => {
    fetchCampaigns({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    {
      campaigns,
      links,
      total_reg,
      page_size,
      page,
      total_pages,
      paginator,
      fetchCampaigns,
      reset,
      loadingCampaigns
    }
  ];
};
